import { getApiPath } from '../../data/api'
import { get } from '../../data/api'
import { getModel } from '../../data/Model'

export async function fetchMarketPricings(pricingType) {
	if (!pricingType) throw new Error('pricingType required')
	return get(`/pricing/markets?pricingType=${encodeURIComponent(pricingType)}`)
}

export async function fetchMarketPricing(market, pricingType) {
	if (!pricingType) throw new Error('pricingType required')
	return get(
		`/pricing/markets/${market}?pricingType=${encodeURIComponent(pricingType)}`,
	)
}

export async function upsertMarketPricing(market, pricingType, payload) {
	if (!pricingType) throw new Error('pricingType required')
	if (payload.currency == null || !/^[A-Z]{3}$/.test(payload.currency))
		throw new Error('Invalid currency code')
	if (payload.licensePrice == null || isNaN(payload.licensePrice))
		throw new Error('licensePrice required')
	if (payload.licensePrice < 0)
		throw new Error('licensePrice must be non-negative')
	if (payload.manipulatedFee != null && payload.manipulatedFee !== '') {
		const mf = Number(payload.manipulatedFee)
		if (isNaN(mf) || mf < 0)
			throw new Error('manipulatedFee must be a non-negative number')
	}
	if (payload.reminderOneFee != null && payload.reminderOneFee !== '') {
		const r1 = Number(payload.reminderOneFee)
		if (isNaN(r1) || r1 < 0)
			throw new Error('reminderOneFee must be non-negative')
	}
	if (payload.reminderTwoFee != null && payload.reminderTwoFee !== '') {
		const r2 = Number(payload.reminderTwoFee)
		if (isNaN(r2) || r2 < 0)
			throw new Error('reminderTwoFee must be non-negative')
	}
	if (payload.ceaseAndDesistFee != null && payload.ceaseAndDesistFee !== '') {
		const cd = Number(payload.ceaseAndDesistFee)
		if (isNaN(cd) || cd < 0)
			throw new Error('ceaseAndDesistFee must be non-negative')
	}
	if (payload.finalWarningFee != null && payload.finalWarningFee !== '') {
		const fw = Number(payload.finalWarningFee)
		if (isNaN(fw) || fw < 0)
			throw new Error('finalWarningFee must be non-negative')
	}
	const res = await fetch(
		getApiPath(
			`/pricing/markets/${market}?pricingType=${encodeURIComponent(pricingType)}`,
		),
		{
			method: 'PUT',
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
				'X-Copyright-Agent-Auth-Token': getModel().auth_token,
			},
			body: JSON.stringify(payload),
		},
	)
	if (!res.ok) throw new Error('Failed to upsert market pricing')
	return res.json()
}

export async function deleteMarketPricing(market, pricingType) {
	if (!pricingType) throw new Error('pricingType required')
	const res = await fetch(
		getApiPath(
			`/pricing/markets/${market}?pricingType=${encodeURIComponent(pricingType)}`,
		),
		{
			method: 'DELETE',
			headers: {
				Accept: 'application/json',
				'X-Copyright-Agent-Auth-Token': getModel().auth_token,
			},
		},
	)
	if (!res.ok) throw new Error('Failed to delete market pricing')
	return res.json()
}

export async function fetchClientMarketPricings(clientId, pricingType) {
	if (!pricingType) throw new Error('pricingType required')
	return get(
		`/pricing/clients/${clientId}/markets?pricingType=${encodeURIComponent(
			pricingType,
		)}`,
	)
}

export async function upsertClientMarketPricing(
	clientId,
	market,
	pricingType,
	payload,
) {
	if (!pricingType) {
		throw new Error('pricingType required')
	}
	const res = await fetch(
		getApiPath(
			`/pricing/clients/${clientId}/markets/${market}?pricingType=${encodeURIComponent(
				pricingType,
			)}`,
		),
		{
			method: 'PUT',
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
				'X-Copyright-Agent-Auth-Token': getModel().auth_token,
			},
			body: JSON.stringify(payload),
		},
	)
	if (!res.ok) throw new Error('Failed to upsert client pricing')
}

export async function deleteClientMarketPricing(clientId, market, pricingType) {
	if (!pricingType) throw new Error('pricingType required')
	const res = await fetch(
		getApiPath(
			`/pricing/clients/${clientId}/markets/${market}?pricingType=${encodeURIComponent(
				pricingType,
			)}`,
		),
		{
			method: 'DELETE',
			headers: {
				Accept: 'application/json',
				'X-Copyright-Agent-Auth-Token': getModel().auth_token,
			},
		},
	)
	if (!res.ok) throw new Error('Failed to delete client pricing')
}

